<div class="dialogform no-print {{largeBreakpoint}}" [class.internal]="internalPortal"  [formGroup]="form">

  <div class="grid-x grid-margin-x">
    <div class="cell {{largeBreakpoint}}-order-1">
      <h2 [innerHTML]="textkeyPrefix + '.dialog.headline' + textkeyPostfix | translate"></h2>
    </div>
    @if (!hideimage) {
      <div class="relative cell {{largeBreakpoint}}-6 {{largeBreakpoint}}-order-3 image-wrapper" [style.background-image]="'url(' +  (advisorImagePath | advisorImageUrl) + ')'">
        @if (copyright) {
          <div class="copyright" [innerHTML]="textkeyPrefix + copyright | translate"></div>
        }
      </div>
    }
    <div class="cell {{largeBreakpoint}}-order-2 teaser-wrapper">
      <p [innerHTML]="textkeyPrefix + '.dialog.teaser' + textkeyPostfix | translate"></p>
    </div>
    <div class="cell {{largeBreakpoint}}-6 list-wrapper {{largeBreakpoint}}-order-4" [innerHTML]="textkeyPrefix + '.dialog.liste' + textkeyPostfix | translate"></div>
  </div>

  @if (result === null) {
    <div class="form-wrapper">
      <div class="grid-x grid-margin-x">
        <div class="cell {{largeBreakpoint}}-order-1">
          @if (error) {
            <div role="alert" class="form-errors" [innerHTML]="(textkeyPrefix + '.dialogform.error.' + error) | translate" #formErrors></div>
          }
        </div>
        @if (showCheckbox) {
          <div class="cell checkbox">
            <input type="checkbox" id="dialogform-terms" name="terms" value="1" formControlName="dialogform-terms">
            <label for="dialogform-terms" [innerHTML]="textkeyPrefix + '.dialogform.terms' | translate"></label>
          </div>
        }
        @if (showName) {
          <div class="cell {{mediumBreakpoint}}-4 {{largeBreakpoint}}-2">
            <label for="dialogform-salutation">{{ textkeyPrefix + '.dialogform.salutation.label' | translate }} @if (markMandatoryFields && mandatoryFields?.indexOf('salutation') > -1) {
              <span class="req">*</span>
            }</label>
            <div class="input-group">
              <select id="dialogform-salutation" [class.error]="form.get('dialogform-salutation').invalid && submitted && error !== 'terms'" name="salutation" formControlName="dialogform-salutation">
                <option value="">{{textkeyPrefix + '.dialogform.salutation.pleasechoose.label' | translate}}</option>
                @for (salutation of salutationOptions; track salutation) {
                  <option [value]="salutation">{{textkeyPrefix + '.dialogform.salutation.' + salutation + '.label' | translate}}</option>
                }
              </select>
            </div>
          </div>
        }
        @if (showName) {
          <div class="cell {{mediumBreakpoint}}-4 {{largeBreakpoint}}-5">
            <label for="dialogform-firstname">{{ textkeyPrefix + '.dialogform.firstname.label' | translate }} @if (markMandatoryFields && mandatoryFields?.indexOf('firstname') > -1) {
              <span class="req">*</span>
            }</label>
            <div class="input-group">
              <input type="text" class="input-group-field" [class.error]="form.get('dialogform-firstname').invalid && submitted && error !== 'terms'" id="dialogform-firstname" name="firstname" formControlName="dialogform-firstname" value="">
            </div>
          </div>
        }
        @if (showName) {
          <div class="cell {{mediumBreakpoint}}-4 {{largeBreakpoint}}-5">
            <label for="dialogform-lastname">{{ textkeyPrefix + '.dialogform.lastname.label' | translate }} @if (markMandatoryFields && mandatoryFields?.indexOf('lastname') > -1) {
              <span class="req">*</span>
            }</label>
            <div class="input-group">
              <input type="text" class="input-group-field" [class.error]="form.get('dialogform-lastname').invalid && submitted && error !== 'terms'" id="dialogform-lastname" name="lastname" formControlName="dialogform-lastname" value="">
            </div>
          </div>
        }
        @if (showAddress) {
          <div class="cell {{mediumBreakpoint}}-8 {{largeBreakpoint}}-4">
            <label for="dialogform-street">{{ textkeyPrefix + '.dialogform.street.label' | translate }} @if (markMandatoryFields && mandatoryFields?.indexOf('street') > -1) {
              <span class="req">*</span>
            }</label>
            <div class="input-group">
              <input type="text" class="input-group-field" [class.error]="form.get('dialogform-street').invalid && submitted && error !== 'terms'" id="dialogform-street" name="street" formControlName="dialogform-street" value="">
            </div>
          </div>
        }
        @if (showAddress) {
          <div class="cell {{mediumBreakpoint}}-4 {{largeBreakpoint}}-2">
            <label for="dialogform-streetnumber">{{ textkeyPrefix + '.dialogform.streetnumber.label' | translate }} @if (markMandatoryFields && mandatoryFields?.indexOf('streetnumber') > -1) {
              <span class="req">*</span>
            }</label>
            <div class="input-group">
              <input type="number" min="1" class="input-group-field" [class.error]="form.get('dialogform-streetnumber').invalid && submitted && error !== 'terms'" id="dialogform-streetnumber" name="streetnumber" formControlName="dialogform-streetnumber" value="">
            </div>
          </div>
        }
        @if (showAddress) {
          <div class="cell {{mediumBreakpoint}}-4 {{largeBreakpoint}}-2">
            <label for="dialogform-postalcode">{{ textkeyPrefix + '.dialogform.postalcode.label' | translate }} @if (markMandatoryFields && mandatoryFields?.indexOf('postalcode') > -1) {
              <span class="req">*</span>
            }</label>
            <div class="input-group">
              <input type="text" class="input-group-field" [class.error]="form.get('dialogform-postalcode').invalid && submitted && error !== 'terms'" id="dialogform-postalcode" name="postalcode" formControlName="dialogform-postalcode" value="">
            </div>
          </div>
        }
        @if (showAddress) {
          <div class="cell {{mediumBreakpoint}}-8 {{largeBreakpoint}}-4">
            <label for="dialogform-city">{{ textkeyPrefix + '.dialogform.city.label' | translate }} @if (markMandatoryFields && mandatoryFields?.indexOf('city') > -1) {
              <span class="req">*</span>
            }</label>
            <div class="input-group">
              <input type="text" class="input-group-field" [class.error]="form.get('dialogform-city').invalid && submitted && error !== 'terms'" id="dialogform-city" name="city" formControlName="dialogform-city" value="">
            </div>
          </div>
        }
        @if (showPhone) {
          <div class="cell {{mediumBreakpoint}}-6">
            <label for="dialogform-phone">{{ textkeyPrefix + '.dialogform.phone.label' | translate }} @if (markMandatoryFields && mandatoryFields?.indexOf('phone') > -1) {
              <span class="req">*</span>
            }</label>
            <div class="input-group">
              <input type="tel" class="input-group-field" [class.error]="form.get('dialogform-phone').invalid && submitted && error !== 'terms'" id="dialogform-phone" name="phone" autocomplete="tel" formControlName="dialogform-phone" value="">
            </div>
          </div>
        }

        @if (showMulitselect) {
          <div class="cell {{mediumBreakpoint}}-6">
            <label for="dialogform-multiselect">{{ textkeyPrefix + '.dialogform.multiselect.label' | translate }} @if (markMandatoryFields && mandatoryFields?.indexOf('multiselect') > -1) {
              <span class="req">*</span>
            }</label>
            <div class="input-group">
              <mat-form-field>
                <mat-select
                  id="dialogform-multiselect"
                  class="multiselect"
                  [class.error]="form.get('dialogform-multiselect').invalid && submitted && error !== 'terms'"
                  [formControlName]="'dialogform-multiselect'"
                  placeholder="{{ textkeyPrefix + '.dialogform.multiselect.placeholder' | translate }}"
                  multiple>
                  @for (option of (multiselectOptions$ | async); track option) {
                    <mat-option [value]="option">{{ option }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }

        @if (showConsultantName) {
          <div class="cell">
            <label for="dialogform-consultant_name">{{ textkeyPrefix + '.dialogform.consultant_name.label' | translate }}</label>
            <div class="input-group">
              <input type="text" class="input-group-field" id="dialogform-consultant_name" name="consultant_name" formControlName="dialogform-consultant_name" value="">
            </div>
          </div>
        }
        <div class="cell {{mediumBreakpoint}}-6">
          <label for="dialogform-email">{{ textkeyPrefix + '.dialogform.email.label' | translate }} @if (markMandatoryFields) {
            <span class="req">*</span>
          }</label>
          <div class="input-group" [class.error]="false">
            <input type="email" class="input-group-field" [class.error]="form.get('dialogform-email').invalid && submitted && error !== 'terms'" id="dialogform-email" name="email" formControlName="dialogform-email" value="" [required]="true" [placeholder]="textkeyPrefix + '.dialogform.email.placeholder' | translate">
          </div>
        </div>
        <div class="cell {{mediumBreakpoint}}-6 dialogform-button">
          <button class="button" [class.signal-cta]="internalPortal" [class.primary]="!internalPortal" (click)="submit()" [innerHTML]="textkeyPrefix + '.dialogform.button' | translate"></button>
        </div>
        @if (!showCheckbox) {
          <div class="cell datenschutz">
            <p [innerHTML]="textkeyPrefix + '.dialogform.datenschutz' | translate"></p>
          </div>
        }
        @if (markMandatoryFields) {
          <div class="cell">
            <p [innerHTML]="textkeyPrefix + '.dialogform.mandatory_fields.text' | translate" class="mandatory-fields-text"></p>
          </div>
        }
      </div>
    </div>
  }
  @if (result !== null) {
    <div class="grid-x form-wrapper" #resultWrapper>
      <div class="cell skipregistration" [class.show-pdf-link]="result === 'skipregistration' && downloadUrl">
        <h3 [innerHTML]="textkeyPrefix + '.dialogform.result.' + result + '.headline' | translate"></h3>
        @if (result === 'skipregistration' && downloadUrl) {
          <a href="{{downloadUrl}}" target="_blank"><span [innerHTML]="textkeyPrefix + '.dialogform.result.' + result + '.text' | translate"></span></a>
        }
        @else {
          <p [innerHTML]="textkeyPrefix + '.dialogform.result.' + result + '.text' | translate"></p>
        }

      </div>
    </div>
  }
</div>
